/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_a280_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A280 (optional)`)
};

const es_od_a280_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A280 (opcional)`)
};

const de_od_a280_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A280 (optional)`)
};

const nl_od_a280_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A280 (optioneel)`)
};

const fr_od_a280_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A280 (optionnel)`)
};

const it_od_a280_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A280 (opzionale)`)
};

const pt_br2_od_a280_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A280 (opcional)`)
};

const pt_od_a280_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A280 (opcional)`)
};

const ja_od_a280_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A280（任意）`)
};

const zh_od_a280_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A280（可选）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_a280_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_a280_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_a280_label", locale)
	if (locale === "en") return en_od_a280_label(inputs)
	if (locale === "es") return es_od_a280_label(inputs)
	if (locale === "de") return de_od_a280_label(inputs)
	if (locale === "nl") return nl_od_a280_label(inputs)
	if (locale === "fr") return fr_od_a280_label(inputs)
	if (locale === "it") return it_od_a280_label(inputs)
	if (locale === "pt-BR") return pt_br2_od_a280_label(inputs)
	if (locale === "pt") return pt_od_a280_label(inputs)
	if (locale === "ja") return ja_od_a280_label(inputs)
	return zh_od_a280_label(inputs)
};